import React, { Component } from 'react';
import AppUtil, { getAppURL } from './../../../utils/AppUtil';
import { DialogsView } from 'nimblework-components';
import { getI18NMessage } from './../../../i18n/I18N';

class EmailVerification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showEmailSuccessMessage: false
        };

        this.sendVerificationEmail = this.sendVerificationEmail.bind(this);
        this.hideMessage = this.hideMessage.bind(this);
    }

    render() {
        const messageConfig = {
            message: 'Verification email sent.',
            noHeaderIcon: true,
            type: 'success'
        };
        const userDetails = this.getUserDetailsFromURL();

        return (
            <div className='notRegisteredDiv'>
                <div className='containerDiv'>
                    <h1 className='firstele'>Email Verification Pending</h1>
                    <div className='secondele'>
                        <span>To access your account, please verify your email address.</span>
                        <br></br>
                        <span>Click the link below to receive the verification email at {decodeURIComponent(userDetails.em)}:</span>
                        <br></br>
                        <span className='click-here' onClick={ this.sendVerificationEmail }>Get Verification Email</span>
                    </div>
                </div>
                <a className='copyright' href='https://www.nimblework.com/'>
                NimbleWork Inc &#169; { new Date().getFullYear() } 
                </a>
                {
                    this.state.showEmailSuccessMessage &&
                        <DialogsView config={ messageConfig } onSelection={ this.hideMessage } getI18NMessage={ getI18NMessage }/>
                }
            </div>
        );
    }

    hideMessage() {
        this.setState({
            showEmailSuccessMessage: false
        });
    }

    sendVerificationEmail() {
        const URL = getAppURL('SEND_EMAIL_VALIDATION');
        const userDetails = this.getUserDetailsFromURL();

        AppUtil.ajax( URL, {
            email: decodeURIComponent(userDetails.em)
        }, () => {
            this.setState({
                showEmailSuccessMessage: true
            });
        }, undefined, undefined, {
            headers: {
                'x-fabric-correlation': `${userDetails.r}:${userDetails.ai}:${userDetails.ui}`
            }
        });
    }

    getUserDetailsFromURL() {
        const userDetails = {};

        location.search.replace('?', '').split('&').forEach(param => {
            const userData = param.split('=');

            userDetails[userData[0]] = userData[1];
        });

        return userDetails;
    }
}

export default EmailVerification;